import { QuizLandingPage } from '@/components/pages/quiz/QuizLandingPage'

export default QuizLandingPage
